<template>
  <div 
    class=" ">
    <v-layout wrap>
      <v-flex>
        <v-dialog v-model="dialog.success"
          width="350">
          <v-card 
            class="border-radius pa-2">
            <v-card-text>
              <v-img 
                width="125"
                height="125"
                alt="kominfoklaten" 
                :src="require('@/assets/icon/info_berhasil.png')"
                class="ma-auto my-6">
                <template v-slot:placeholder>
                  <v-row
                    class=" "
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      size="20"
                      indeterminate 
                      :color="set_color">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>

              <div
                class="body-1 text-center line-text-second">
                <div>
                  Terima kasih, profil Anda
                </div>

                <div>
                  telah berhasil diubah!
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>

        <section>
          <v-card
            flat
            class="mb-3"
            style="overflow-y: auto;">
            <v-card-text
              class="pa-1 pt-3">
              <div class="mb-4">
                Silahkan isi data diri Anda dengan benar, agar kami dapat memberikan layanan yang lebih baik.
              </div>

              <v-divider class="mb-4"></v-divider>
              <ValidationObserver 
                ref="form">
                <v-form>
                  <div
                    class="mb-4">

                    <v-card flat width="200" class="mb-4">
                      <v-card-title class="pa-0 text-center">

                        <v-img
                          :src="form.image_url !== undefined && form.image_url !== '' ? form.image_url : require('@/assets/image/member_default.png')"
                          width="200"
                          height="200"
                          :gradient="process.image ? `to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)` : ''"
                          style="border-radius: 16px; border: 2px solid #EBEBEB; 
                            border-style: dashed;">
                          <v-row
                            class="fill-height ma-0"
                            v-if="process.image"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular
                              indeterminate
                              color="grey lighten-5"
                            ></v-progress-circular>
                          </v-row>
                        </v-img>
                        <div class="mt-2">
                          <uploadfolder
                            v-model="upload.image">
                            <div 
                              slot="activator">
                              <v-btn
                                class="text-capitalize white--text"
                                width="200"
                                height="40"
                                outlined
                                style="border-radius: 8px;"
                                :disabled="process.image"
                                color="grey darken-2"
                                elevation="0"
                              >
                                <v-icon dark size="22">
                                  mdi-pencil
                                </v-icon>
                                Pilih Foto
                              </v-btn>
                            </div>
                          </uploadfolder>
                        </div>
                      </v-card-title>
                    </v-card>

                    <ValidationProvider
                      name="Nama" 
                      rules="required" 
                      v-slot="{ errors }">
                      <div class="body-2 mb-2">
                        Nama
                        <span class="red--text">*</span>
                      </div>

                      <v-text-field
                        v-on:keydown.enter.prevent="save()"
                        solo
                        rounded
                        dense

                        :color="set_color"
                        placeholder="Contoh. Klinik Kecantikan"

                        v-model="form.name"
                        :error-messages="errors"
                        required
                        
                        style="border-radius: 6px; width: 50%;">
                      </v-text-field>
                    </ValidationProvider>

                    <ValidationProvider 
                      name="Email" 
                      rules="required|email" 
                      v-slot="{ errors }">
                      <div class="body-2 mb-2">
                        
                        Email
                        <span class="red--text">*</span>
                      </div>

                      <v-text-field
                        v-on:keyup.enter="save()"
                        
                        solo
                        rounded
                        dense

                        disabled
                        

                        :color="set_color"
                        placeholder="Contoh. XXXX@gmail.com"

                        v-model="form.email"
                        :error-messages="errors"
                        required
                        style="border-radius: 6px; width: 40%;">
                      </v-text-field>
                    </ValidationProvider>

                    <ValidationProvider 
                      name="Mobilephone" 
                      rules="required|min:9|max:13" 
                      v-slot="{ errors }">
                      <div class="body-2 mb-2">
                        
                        Mobilephone
                        <span class="red--text">*</span>
                      </div>

                      <v-text-field
                        v-on:keyup.enter="save()"
                        
                        outlined
                        rounded
                        dense
                        prefix="+62"

                        onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                        type="number"
                        min="0"

                        :color="set_color"
                        placeholder="81XXXXXXXXX"

                        v-model="form.mobilephone"
                        :error-messages="errors"
                        required
                        style="border-radius: 6px; width: 30%;">
                      </v-text-field>
                    </ValidationProvider>
                    

                  </div>
                  
                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center my-4 d-flex align-center">
                <div
                  class="error--text">
                  <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
          </v-card>
          <v-divider></v-divider>
          <div class="text-right pt-5">
            <v-btn 
              @click="save()"
              :loading="process.form"
              :disabled="process.form"
              :color="set_color"
              elevation="0"
              width="120"
              height="40"
              class="body-2 white--text text-capitalize ml-3"
              style="border-radius: 6px; font-weight: 600;">
              <span>
                Simpan
              </span>
            </v-btn>
          </div>

        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    props: {
      form: {
        type: Object,
        default: {}
      }
    },
    data () {
      return {
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu: false,
        modal: false,
        menu2: false,

        image_url: '',

        show: {
          old_password: false,
          new_password: false
        },

        dialog: {
          success: false
        },

        upload: {
          image: null
        },

        process: {
          form: false,

          image: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
    },
    watch: {
      'upload.image': {
        handler: function () {
          if (this.upload.image) {
            this.process.image = this.upload.image.process

            if (!this.process.image) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.form.image_url = this.upload.image.fileuri

              // this.save_image()
            }
          }
        },
        deep: true
      }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      
    },
    methods: {
      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          // SAVE TO REST API
          let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? `pegawai/account/update` : `account/update`
          await post(`${url}`, {
            data: this.form
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {
              let user = this.$store.state.user
              user.name = this.form.name
              user.mobilephone = `62${this.form.mobilephone}`
              user.image_url = this.form.image_url

              // console.log(user)

              TokenService.saveToken(
                this.$store.state.token,
                JSON.stringify(user),
                JSON.stringify(this.$store.state.menu)
              )

              this.$store.state.user = user

              this.dialog.success = true
            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      async save_image () {
        this.message.error = ''

        // SAVE TO REST API
        // await post(`admin/profile_user/update`, {
        //   data: this.form
        // })
        // .then((response) => {
        //   let res = response.data

        //   if (res.status === 200) {
        //     let user = {
        //       id: this.form.id,
                
        //       name: this.form.name,
        //       nip: this.form.nip,

        //       email: this.form.email,
        //       mobilephone: this.form.mobilephone,
              
        //       image_url: this.form.image_url,
        //       gender: this.form.gender
        //     }

        //     TokenService.saveToken(
        //       this.$store.state.token,
        //       JSON.stringify(user),
        //       JSON.stringify(this.$store.state.menu)
        //     )

        //     this.$store.state.user = user
        //   } else {
        //     this.message.error = res.message
        //   }
        // })
      }
    }
  }
</script>